import axios from "axios";
// import { useState } from "react";
// import { fetchUserDetail } from "./fetchUserDetails";
import { CreateWebHook } from "./createWebhook";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



export const ApproveStatus = async (userId, catalogItemId, directLinkId, priorities, userDetails) => {
  try {
    const url = process.env.REACT_APP_API_URL;
    const id = userDetails._id;
    const shopUrl = userDetails.shopUrl;
    const shopName = userDetails.shopName;

  

    const res = await axios.post(`${url}/api/updateStatus/${id}`, null);
    if (res.status === 200) {
      // toast.success(res.data.message);

      await CreateWebHook(userId, catalogItemId, directLinkId, priorities, id, shopUrl, shopName,userDetails);
    } else {
      console.log(res.message)
      // toast.error(res.message)
    }
  } catch (error) {
    console.error("Error approving status:", error);
    // toast.error(error.response ? error.response.message : error.message);
  }
};



export const SaveStatus = async (userId, catalogItemId, directLinkId, priorities, userDetails) => {
  try {
    const url = process.env.REACT_APP_API_URL;
    const id = userDetails._id;
    const shopUrl = userDetails.shopUrl;
    const shopName = userDetails.shopName;
  

    const res = await axios.post(`${url}/api/updateDetail`, {userId, catalogItemId, directLinkId, priorities, id, shopUrl, shopName});
    if (res.status === 200) {
      toast.success("updated Successfully");
    } else {
      console.log(res.message)
      toast.error(res.message)
    }
  } catch (error) {
    console.error("Error updating detail:", error);
    toast.error("Error updating detail:")
  }
};